import React from 'react';
import styled from 'styled-components';
import AboutTopBar from '../component/about/AboutTopBar';
import AboutTopBarFixed from '../component/about/AboutTopBarFixed';
import MemberInfo from '../component/about/MemberInfo';
import CareerList from '../component/about/CareerList';
import { useShortCut } from '../shared/hooks/useShortCut';
import ArchivePageFrame from '../shared/component/ArchivePageFrame';
import { useNavLayout } from '../shared/hooks/useNavLayout';
import { useAboutPage } from '../shared/hooks/page/useAboutPage';
import { AboutContentMode, DeviceType, NavLayout } from '../shared/enum/EnumRepository';
import HintWrapper from '../shared/component/headless/button/HintWrapper';
import { getHintMessage } from '../shared/constants/hintMessages';
import UniversalIconBtn from '../shared/component/headless/button/UniversalIconBtn';
import downloadIcon from '../asset/icon/download.png';
import reorderIcon from '../asset/icon/reorder.png';
import confirmIcon from '../asset/icon/confirm2.png';
import confirmIcon2 from '../asset/icon/confirm3.png';


const About: React.FC = () => {
  const { handleCmdE, handleCmdSlash } = useShortCut();
  const navLayout = useNavLayout();
  const {
    aboutContentMode,
    setAboutContentMode,
    isEditMode,
    engVisible,
    deviceType,
    canReorderCareerSections,
    hasAboutChanged,
    handleConfirmAll,
    handleDownloadPDF,
    handleReorderCareerSections,
  } = useAboutPage({ load: true });
  const canToggleContentMode = isEditMode || engVisible;

  return (
    <ArchivePageFrame
      onKeyDown={(e) => {
        handleCmdE(e);
        if (!canToggleContentMode) return;
        handleCmdSlash(e, () => {
          setAboutContentMode(
            aboutContentMode === AboutContentMode.Orig
              ? AboutContentMode.ENG
              : AboutContentMode.Orig,
          );
        });
      }}
      tabIndex={-1}
    >
      {navLayout === NavLayout.FIXED ? <AboutTopBarFixed /> : <AboutTopBar />}
      <MemberInfo />
      <CareerList />
      {(isEditMode && deviceType !== DeviceType.MOBILE) &&
        <BtnContainer>
          {hasAboutChanged && (
            <UniversalIconBtn
              isPrimary
              size="standard"
              border={false}
              backgroundImg={confirmIcon}
              backgroundImgHover={confirmIcon2}
              onClick={handleConfirmAll}
            />
          )}
          {canReorderCareerSections && (
            <HintWrapper
              content={getHintMessage('REORDER_CAREER_SECTIONS')}
              toLeft={true}>
              <UniversalIconBtn
                size="standard"
                border={false}
                backgroundImg={reorderIcon}
                onClick={handleReorderCareerSections}
              />
            </HintWrapper>
          )}
          <HintWrapper
            content={getHintMessage('DOWNLOAD_CV_PDF')}
            toLeft={true}>
            <UniversalIconBtn
              size="standard"
              border={false}
              backgroundImg={downloadIcon}
              onClick={handleDownloadPDF}
            />
          </HintWrapper>
        </BtnContainer>
      }
    </ArchivePageFrame>
  );
}

export default About;

const BtnContainer = styled.div`
  position: fixed;
  bottom: clamp(25px, 3vw, 50px);
  right: clamp(25px, 6vw, 75px);
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: clamp(5px, 0.6vw, 15px);
  z-index: 4;
`;
